import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { BossHomePayments } from '@utils/models/BossHome';
import { stringifyUrl } from 'query-string';
import { useQuery } from 'react-query';
import { StringParam, useQueryParams } from 'use-query-params';

import { queryKeys } from '../constants';

export function useBossHomePayments() {
  const [query] = useQueryParams({
    houses: StringParam,
    buildings: StringParam
  });

  return useQuery<BossHomePayments>(
    [queryKeys.BOSS_HOME_PAYMENTS, query],
    async () => {
      const res = await $api.get(
        stringifyUrl({
          url: `/v1/mobile/payment`,
          query
        })
      );

      return res?.data?.data;
    },
    {
      refetchOnWindowFocus: false,
      onError: baseErrorHandler,
      retry: false
    }
  );
}
